<template>
  <div class="welfare">
    <header>
      <!-- <div class="logo" :style="{ 'background-image': `url(${$t('welfare.logo_s')})` }"></div> -->
      <div
        class="name"
      >{{serversName}} {{ userinfo ? userinfo.name : ''}}</div>
      <div @click="back" class="back">{{$t('welfare.back')}}</div>
    </header>
    <div class="content">
      <div class="gumballs">
        <div class="bg-gumballs-top"></div>
        <div class="activity-content">
          <h1>{{$t('welfare.gumballs_activity.time.title')}}</h1>
          <p class="time">
            <span>{{$t('welfare.gumballs_activity.time.year_start')}}</span>
            <span>{{$t('welfare.gumballs_activity.time.month_day_start')}}</span>
            <span>—</span>
            <span>{{$t('welfare.gumballs_activity.time.year_end')}}</span>
            <span>{{$t('welfare.gumballs_activity.time.month_day_end')}}</span>
          </p>
          <h1>{{$t('welfare.gumballs_activity.content.title')}}</h1>
          <p
            class="activity-way"
            v-html="item"
            v-for="(item,index) in $t('welfare.gumballs_activity.content.way')"
            :key="index"
          >{{item}}</p>
        </div>
        <div class="code" @click="getCode">{{$t('welfare.gumballs_activity.get_code')}}</div>
        <div class="download" @click="download">{{$t('welfare.gumballs_activity.download')}}</div>
      </div>
      <div class="sdorica">
        <div class="bg-sdorica-top"></div>
        <div class="activity-content">
          <h1>{{$t('welfare.sdorica_activity.time.title')}}</h1>
          <p class="time">
            <span>{{$t('welfare.sdorica_activity.time.year_start')}}</span>
            <span>{{$t('welfare.sdorica_activity.time.month_day_start')}}</span>
            <span>—</span>
            <span>{{$t('welfare.sdorica_activity.time.year_end')}}</span>
            <span>{{$t('welfare.sdorica_activity.time.month_day_end')}}</span>
          </p>
          <h1>{{$t('welfare.sdorica_activity.content.title')}}</h1>
          <p
            class="activity-way"
            v-html="item"
            v-for="(item,index) in $t('welfare.sdorica_activity.content.way')"
            :key="index"
          >{{item}}</p>
        </div>
        <div class="enter-code">
          <label for="code">{{$t('welfare.sdorica_activity.label')}}</label>
          <input
            type="text"
            maxlength="12"
            id="code"
            :class="[noEnter?'color-no-enter':'color']"
            :placeholder="noEnter?$t('welfare.sdorica_activity.noEnter_placeholder'):$t('welfare.sdorica_activity.placeholder')"
            v-model.trim="sdoricaCode"
          />
        </div>
        <div
          class="welfare-btn"
          @click="getWelfare"
          :style="{ 'background-image': getWelfareFlag?`url(${get})`:`url(${notget})`}"
        >{{getWelfareFlag?$t('welfare.sdorica_activity.got_welfare'):$t('welfare.sdorica_activity.get_welfare')}}</div>
      </div>
    </div>
    <Code :code="code" :visibilityFlag.sync="codeFlag" />
    <Result :type="type" :visibilityFlag.sync="resultFlag" :message="messageFailed" />
  </div>
</template>

<script>
import { value, onMounted } from "vue-function-api";
import Code from "../../components/modal";
import Result from "../../components/modal";
import axios from "../../utils/axios";
import session from "../../utils/session";
import notget from "../../assets/images/btn.png";
import get from "../../assets/images/get_btn.png";
import { LOCALE_MAP_2B } from "../../utils/constants";

export default {
  components: {
    Code,
    Result
  },
  setup(props, context) {
    const {
      root: { $router, $i18n }
    } = context;
    const link = "http://onelink.to/gumball"
    const code = value("");
    const sdoricaCode = value("");
    const messageFailed = value("");
    const type = value(false);
    const resultFlag = value(false);
    const codeFlag = value(false);
    const userinfo = value({});
    const noEnter = value(false);
    const serversName = value("");
    const getWelfareFlag = value(false);
    onMounted(() => {
      userinfo.value = session.getObject("userinfo");
      getWelfareFlag.value = userinfo.value.isCodeRewarded;
      serversName.value =
        userinfo.value.serversName[userinfo.value.zone][
          LOCALE_MAP_2B[$i18n.locale]
        ];
    });
    const back = () => {
      $router.push({
        path: "/home"
      });
    };
    //获取礼品码
    const getCode = async () => {
      let { code: codeRes, data } = await axios.get("/linkage_event/code");
      if (codeRes === 200) {
        type.value = true;
        codeFlag.value = true;
        code.value = data.linkageEventCode.code;
      } else {
        type.value = false;
        messageFailed.value = $i18n.te(`network_error.${data.error}`) ? 
              $i18n.t(`network_error.${data.error}`)
              :
              (  session.getString("token") ? 
                    $i18n.t(`network_error.OTHER`) : $i18n.t(`network_error.NO_TOKEN`)
              )
        resultFlag.value = true;
      }
    };
    //获取限定福利
    const getWelfare = async () => {
      if (!getWelfareFlag.value) {
        if (sdoricaCode.value !== "") {
          noEnter.value = false;
          let { code, data } = await axios.postForm("/linkage_event/reward", {
            code: sdoricaCode.value,
            type: "code"
          });
          if (code === 200) {
            type.value = true;
            getWelfareFlag.value = true;
          } else {
            type.value = false;
            messageFailed.value = $i18n.te(`network_error.${data.error}`) ? 
              $i18n.t(`network_error.${data.error}`)
              :
              (  session.getString("token") ? 
                    $i18n.t(`network_error.OTHER`) : $i18n.t(`network_error.NO_TOKEN`)
              )
          }
          resultFlag.value = true;
          sdoricaCode.value = "";
        } else {
          noEnter.value = true;
        }
      }
    };
    const download = () =>{
      window.location.href = link
    }
    return {
      serversName,
      noEnter,
      back,
      getCode,
      download,
      getWelfare,
      code,
      type,
      codeFlag,
      sdoricaCode,
      userinfo,
      messageFailed,
      resultFlag,
      getWelfareFlag,
      get,
      notget
    };
  }
};
</script>

<style lang="scss" scoped>
// $u: 0.01333333334;
// $h: $u * 190rem;
// .welfare {
//   width: 100%;
//   min-height: calc(100vh - #{$h});
//   background-color: #191919;
//   padding-bottom: $u * 84rem;
//   header {
//     display: flex;
//     justify-content: space-between;
//     width: 100%;
//     height: $u * 100rem;
//     background: url("../../assets/images/welfare_background.png");
//     background-size: 100% 100%;
//     padding: 0 $u * 32rem;
//     box-sizing: border-box;
//     align-items: center;
//     .logo {
//       width: $u * 298rem;
//       height: $u * 58rem;
//       // background: url("../../assets/images/logo_s.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//     .name {
//       font-size: $u * 32rem;
//       color: #f7e5d2;
//       font-weight: bold;
//     }
//     .back {
//       width: $u * 194rem;
//       height: $u * 54rem;
//       background: url("../../assets/images/back.png") center no-repeat;
//       background-size: 100% 100%;
//       font-size: $u * 24rem;
//       font-weight: bold;
//       color: rgba(255, 255, 255, 1);
//       padding-left: $u * 26rem;
//       box-sizing: border-box;
//       line-height: $u * 54rem;
//     }
//   }
//   .content {
//     width: 100%;
//     padding: 0 $u * 32rem;
//     box-sizing: border-box;
//     .activity-content {
//       box-sizing: border-box;
//       padding: $u * 118rem $u * 38rem 0 $u * 62rem;
//       p {
//         margin: 0;
//       }
//       h1 {
//         color: #ffebd6;
//         font-size: $u * 24rem;
//         line-height: $u * 44rem;
//         position: relative;
//         margin: 0;
//         &::before {
//           content: "";
//           width: $u * 14rem;
//           height: $u * 14rem;
//           background: url("../../assets/images/circle_s.png");
//           background-size: 100% 100%;
//           position: absolute;
//           top: $u * 18rem;
//           left: -$u * 26rem;
//         }
//       }
//       .time {
//         color: #ffebd6;
//         font-size: $u * 24rem;
//         line-height: $u * 44rem;
//         margin: 0;
//         span:nth-of-type(2),
//         span:nth-of-type(5) {
//           color: #f6b166;
//           font-weight: 800;
//         }
//       }
//       .activity-way {
//         color: #ffebd6;
//         font-size: $u * 24rem;
//         line-height: $u * 44rem;
//         margin: 0;
//         span {
//           color: #f6b166;
//           font-weight: 800;
//         }
//       }
//     }
//     .gumballs {
//       margin-top: $u * 62rem;
//       width: 100%;
//       // height: $u * 804rem;
//       background: url("../../assets/images/gumballs_border.png") center no-repeat;
//       background-size: 100% 100%;
//       box-sizing: border-box;
//       padding-bottom: $u * 42rem;
//       .code,
//       .download {
//         width: $u * 610rem;
//         height: $u * 100rem;
//         background: url("../../assets/images/btn.png") center no-repeat;
//         background-size: contain;
//         font-size: $u * 38rem;
//         color: #4c2d1a;
//         font-weight: 800;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         margin: 0 auto;
//       }
//       .code {
//         margin-bottom: $u * 20rem;
//         margin-top: $u * 30rem;
//       }
//     }
//     .sdorica {
//       margin-top: $u * 76rem;
//       width: 100%;
//       // height: $u * 804rem;
//       background: url("../../assets/images/sdorica_border.png") center no-repeat;
//       background-size: 100% 100%;
//       padding-bottom: $u * 42rem;
//       box-sizing: border-box;

//       .enter-code {
//         margin: 0 auto;
//         width: $u * 610rem;
//         font-size: $u * 28rem;
//         margin-bottom: $u * 20rem;
//         margin-top: $u * 20rem;
//         label {
//           font-size: $u * 28rem;
//           font-weight: bold;
//           color: rgba(255, 235, 214, 1);
//           line-height: $u * 52rem;
//           letter-spacing: 1px;
//         }
//         input {
//           outline: none;
//           border: none;
//           width: $u * 494rem;
//           height: $u * 54rem;
//           background: url("../../assets/images/input.png") center no-repeat;
//           background-size: contain;
//           padding-left: $u * 10rem;
//           box-sizing: border-box;
//           font-size: $u * 28rem;
//           color: rgba(230, 230, 230, 1);
//           line-height: $u * 52rem;
//         }
//         ::-webkit-input-placeholder {
//           /* WebKit browsers */
//           font-size: $u * 28rem;
//           color: rgba(230, 230, 230, 1);
//           line-height: $u * 52rem;
//         }
//         :-moz-placeholder {
//           /* Mozilla Firefox 4 to 18 */
//           font-size: $u * 28rem;
//           color: rgba(230, 230, 230, 1);
//           line-height: $u * 52rem;
//         }
//         ::-moz-placeholder {
//           /* Mozilla Firefox 19+ */
//           font-size: $u * 28rem;
//           color: rgba(230, 230, 230, 1);
//           line-height: $u * 52rem;
//         }
//         :-ms-input-placeholder {
//           /* Internet Explorer 10+ */
//           font-size: $u * 28rem;
//           color: rgba(230, 230, 230, 1);
//           line-height: $u * 52rem;
//         }
//       }
//       .welfare-btn {
//         width: $u * 610rem;
//         height: $u * 100rem;
//         background: url("../../assets/images/btn.png") center no-repeat;
//         background-size: contain;
//         font-size: $u * 38rem;
//         color: #4c2d1a;
//         font-weight: 800;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         margin: 0 auto;
//       }
//     }
//   }
// }
</style>